import { API_METHOD, NAMESPACE_API_PATH } from '~/app/shared/utils/consts/api';

export const BiometryEndpoints = $api => {
  $api.register('biometry-public-api', NAMESPACE_API_PATH.PUBLIC, request => ({
    getConfig() {
      return request(API_METHOD.GET, '/biometry/config');
    },
  }));

  $api.register('biometry-private-api', NAMESPACE_API_PATH.PRIVATE, request => ({
    create(payload) {
      return request(API_METHOD.POST, '/biometry', payload);
    },
    getActualStatus() {
      return request(API_METHOD.GET, '/biometry/actual');
    },
    uploadPhoto(payload) {
      return request(API_METHOD.POST, '/biometry/file/upload', payload);
    },
  }));

  $api.register('biometry', NAMESPACE_API_PATH.PRIVATE, request => ({
    uploadPhotos(payload) {
      return request('POST', '/document/file-upload', payload);
    },
    uploadVideo(payload) {
      return request('POST', '/document/file-video-upload', payload);
    },
  }));
};
